module.exports = __webpack_public_path__ + "img/provider-chatgpt.755f4cec.png";